import React from 'react';
import thumbsup from '../../assets/images/thumbsup.svg';
import insightsIcon from '../../assets/images/Insights.svg';
import EyeIcon from '../../assets/images/EyeIcon.svg';
import Share from '../../assets/images/Share.svg';
import Save from '../../assets/images/Save.svg';
import { ThumbsUp, Eye, Forward, Bookmark, BarChart2 } from 'lucide-react';
import { useNavigate } from "react-router-dom";

import "./VideoCard.css"

const VideoCard = ({ title, time, likes, views, shares, saves, thumbnail, item, contentType }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
      navigate("/video-insights", { state: { item, contentType } });
  }

  return (
    <div className="flex justify-between items-start pt-8 hover:bg-gray-50 transition-colors px-10 gap-8">
      {/* Left Content */}
      <div className="flex-1 flex flex-col items-start mt-2">
        <h3 className="font-bold text-[16px] text-[#0D0F1C] leading-tight mb-1 pr-4 f-fam-name-spline-sans">
          {title}
        </h3>
        <p className="text-[14px] text-[#606060] mb-4 f-fam-name-roboto font-normal">{time}</p>
        
        <div className="flex items-center space-x-6 mb-5 text-[14px] font-medium text-gray-500">
          <div className="flex items-center space-x-2">
            <img src={thumbsup} alt="Like" />
            <span className="f-fam-name-figtree text-[12px] text-[#605F5F] font-normal">{likes}</span>
          </div>
          <div className="flex items-center space-x-2">
          <img src={EyeIcon} alt="EyeIcon" />
            <span className="f-fam-name-figtree text-[12px] text-[#605F5F] font-normal">{views} views</span>
          </div>
          <div className="flex items-center space-x-2">
          <img src={Share} alt="Share" />
            <span className="f-fam-name-figtree text-[14px] text-[#605F5F] font-medium">{shares}</span>
          </div>
          {saves !== undefined && (
            <div className="flex items-center space-x-2">
          <img src={Save} alt="Save" />
              <span className="f-fam-name-figtree text-[14px] text-[#605F5F] font-medium">{saves}</span>
            </div>
          )}
        </div>
        
        <button className="flex items-center space-x-2 bg-brandPurple px-2 py-2 rounded-md hover:bg-purple-700" onClick={handleNavigate}>
          {/* <BarChart2 className="w-4 h-4" strokeWidth={2.5} /> */}
          <img src={insightsIcon} alt="Insights" />
          <span className="f-fam-name-inter text-[12px] text-[#FFFFFF] font-semibold">Insights</span>
        </button>
      </div>
      
      {/* Right Thumbnail */}
      <div className="w-[320px] h-[171px] rounded-[12px] overflow-hidden shrink-0 shadow-sm bg-gray-100 relative">
        <img 
          src={thumbnail} 
          alt={title} 
          className="w-profile h-profile object-cover"
        />
        {/* Abstract volume off icon matching screenshot top right */}
        <div className="absolute top-3 right-3 text-white drop-shadow-md">
           <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" />
           </svg>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
